const GRADE_ORDINALS = ["1er grade", "2ème grade", "3ème grade", "4ème grade", "5ème grade"];

const GRADE_REQUIREMENTS = {
  "regent-tresor": {
    unit: {
      one: "coffre obtenu au jeu de vocabulaire",
      other: "coffres obtenus au jeu de vocabulaire",
    },
    thresholds: [50, 150, 500, 750, 1500],
  },
  "quinze-souverain": {
    unit: {
      one: "score parfait 15/15",
      other: "scores parfaits 15/15",
    },
    thresholds: [50, 150, 500, 750, 1500],
  },
  "queteur-emerite": {
    unit: {
      one: "quête validée",
      other: "quêtes validées",
    },
    thresholds: [10, 75, 150, 220, 288],
  },
  "franc-veneur": {
    unit: {
      one: "mot capturé",
      other: "mots capturés",
    },
    thresholds: [1500, 2500, 3500, 6000, 10000],
  },
  "chasseur-tresors": {
    unit: {
      one: "relique obtenue",
      other: "reliques obtenues",
    },
    thresholds: [7, 20, 40, 72, 114],
  },
  "gardien-reliques": {
    unit: {
      one: "collection complète",
      other: "collections complètes",
    },
    thresholds: [2, 3, 6, 10, 15],
  },
  apothicaire: {
    unit: {
      one: "potion gagnée",
      other: "potions gagnées",
    },
    thresholds: [10, 25, 50, 100, 200],
  },
  joaillier: {
    unit: {
      one: "type de pierre",
      other: "types de pierres",
    },
    thresholds: [7, 12, 15, 20, 28],
  },
  "grand-lecteur": {
    unit: {
      one: "heure de lecture",
      other: "heures de lecture",
    },
    thresholds: [25, 100, 250, 500, 1000],
  },
  "seigneur-vignoble": {
    unit: {
      one: "mot maîtrisé",
      other: "mots maîtrisés",
    },
    thresholds: [1200, 2000, 2800, 4800, 8000],
  },
  "capitaine-vaisseau": {
    unit: {
      one: "session d'entraînement",
      other: "sessions d'entraînement",
    },
    thresholds: [30, 90, 150, 300, 1500],
  },
  mnemosyne: {
    unit: {
      one: "score 14/15 ou 15/15",
      other: "scores 14/15 ou 15/15",
    },
    thresholds: [5, 25, 100, 250, 500],
  },
  "jour-radieux": {
    unit: {
      one: "titre acquis",
      other: "titres acquis",
    },
    thresholds: [1, 3, 6, 10, 12],
  },
};

export function getRadiantDayGradeRequirementTooltip(titleId, gradeLevel) {
  const definition = GRADE_REQUIREMENTS[titleId];
  const ordinal = GRADE_ORDINALS[gradeLevel - 1];
  const threshold = definition?.thresholds?.[gradeLevel - 1];
  if (!definition || !ordinal || threshold == null) return "";

  const unit = threshold === 1 ? definition.unit.one : definition.unit.other;
  return `${ordinal}. ${threshold} ${unit}.`;
}
